import React from 'react';

import { OrganizationLinkPressable } from '../components';
import { type Props } from '../OrganizationLink.types';

// ─────────────────────────────────────────────────────────────────────────────

export const OrganizationLinkPrivacyChoices = (props: Props) => {
  const { link, textStyle } = props;

  return (
    <OrganizationLinkPressable
      link={link}
      onPress={handlePrivacyChoicesPress}
      textStyle={textStyle}
    />
  );
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function handlePrivacyChoicesPress() {
  (globalThis as GlobalOneTrust)?.OneTrust?.ToggleInfoDisplay?.();
}

// ─── Types ───────────────────────────────────────────────────────────────────

type GlobalOneTrust = {
  OneTrust?: { ToggleInfoDisplay?: () => void };
};
